import { Figure, H3, Menu, Note, OL, P, Table, UL } from './GuideKit';

export function Overview() {
  return (
    <>
      <P>
        Zaslonka je spletna platforma za fotografska tekmovanja. Organizatorji (na primer fotografska društva) objavijo
        razpis, fotografi oddajo svoje fotografije, sodniki jih ocenijo, organizator pa na koncu podeli nagrade.
        Vse poteka v brskalniku, brez nameščanja programov.
      </P>
      <P>Pot ene fotografije od začetka do konca:</P>
      <OL>
        <li>Organizator ustvari tekmovanje, napiše razpis in določi zahteve za slike.</li>
        <li>Fotograf se prijavi na tekmovanje in odda fotografijo.</li>
        <li>Organizator pregleda prispevke: sprejme jih ali zavrne.</li>
        <li>Sodniki sprejete prispevke anonimno ocenijo z ocenami od 1 do 10.</li>
        <li>Ocenjevanje se zaključi. Organizator izbere delež najboljših prispevkov za razstavo in podeli nagrade.</li>
        <li>Organizator objavi rezultate: povprečne ocene, mesta, izbor za razstavo in nagrade.</li>
        <li>Tekmovalci vidijo svoje rezultate.</li>
      </OL>
      <Note>
        Stran z navodili je javna. Berete jo lahko tudi brez računa, na naslovu <Menu>/navodila-za-uporabo</Menu>.
      </Note>
    </>
  );
}

export function Roles() {
  return (
    <>
      <P>
        Vloge niso vezane na račun, ampak na tekmovanje ali organizacijo. Ista oseba je lahko v enem tekmovanju sodnik, v
        drugem tekmovalec, v tretjem organizator. Meni na levi vedno pokaže samo tisto, kar vam v vsaj enem tekmovanju
        pripada.
      </P>
      <Table
        head={['Vloga', 'Kdo je', 'Kaj lahko']}
        rows={[
          [
            'Obiskovalec',
            'Kdorkoli, tudi brez računa',
            'Prebere javni razpis tekmovanja in te navodila. Za sodelovanje potrebuje račun.',
          ],
          [
            'Tekmovalec',
            'Uporabnik, ki ga je organizator sprejel (ali dodal) na tekmovanje',
            'Oddaja in ureja svoje prispevke, vidi svoje rezultate in nagrade. Vidi vsebino tekmovanja, v katerem sodeluje.',
          ],
          [
            'Sodnik',
            'Uporabnik, ki ga je organizator določil za sodnika na tekmovanju',
            'Ocenjuje sprejete prispevke, ko je ocenjevanje odprto. Razvrstitev vidi šele, ko je ocenjevanje zaključeno.',
          ],
          [
            'Organizator in skrbnik organizacije',
            'Član organizacije (društva), ki prireja tekmovanje',
            'Ustvari in vodi tekmovanja svoje organizacije: razpis, kategorije, tekmovalce, sodnike, pregled prispevkov, nagrade in poročila. Sodnik na tekmovanju ne more biti hkrati organizator iste organizacije.',
          ],
        ]}
      />
    </>
  );
}

export function GettingStarted() {
  return (
    <>
      <H3>Registracija in prijava</H3>
      <UL>
        <li>
          Računa ni mogoče ustvariti kar tako: ustvarite ga prek povezave na tekmovanje, ki jo dobite od organizatorja
          (stran razpisa, gumb <Menu>Ustvari račun in se prijavi</Menu>). Vpišete ime, priimek, e-pošto in geslo, s tem
          pa ste tudi že prijavljeni na tekmovanje. Dobite pozdravno e-pošto.
        </li>
        <li>
          Prijavite se z e-pošto in geslom. Prijava velja v vseh zavihkih istega brskalnika, odjava v enem zavihku vas odjavi povsod. Seja poteče po daljšem času nedejavnosti, takrat se prijavite znova.
        </li>
        <li>
          <Menu>Pozabljeno geslo</Menu>: vpišite e-pošto in prejeli boste enkratno povezavo, veljavno eno uro. Ob
          spremembi gesla se vse seje končajo in dobite obvestilo.
        </li>
      </UL>
      <H3>Povabilo na platformo</H3>
      <P>
        Če vas je organizator ali administrator dodal ročno, vam ni nastavil gesla. Na e-pošto prejmete povezavo (velja
        sedem dni, deluje enkrat), kjer sami izberete geslo. Potem se prijavite kot običajno.
      </P>
      <H3>Moj račun</H3>
      <P>
        Na strani <Menu>Moj račun</Menu> spremenite osebne podatke, e-naslov za prijavo in geslo. Ob spremembi e-naslova
        obvestilo dobi stari naslov. Za spremembo gesla morate vpisati trenutno geslo.
      </P>
      <H3>Izbira tekmovanja</H3>
      <UL>
        <li>
          Registrirate se samo enkrat, v vsakem tekmovanju pa imate svojo vlogo (tekmovalec, sodnik ali organizator).
          Po prijavi vidite kartice samo tistih tekmovanj, v katera ste vključeni. Kartice, razvrščene po vaši vlogi (organiziram, ocenjujem, sodelujem), drsite
          vodoravno in pritisnite kartico tekmovanja.
        </li>
        <li>
          Če ste vključeni samo v eno tekmovanje, se odpre kar samo. Meni na levi nato kaže samo možnosti za vašo
          vlogo v tem tekmovanju.
        </li>
        <li>
          Za drugo tekmovanje pritisnite <Menu>Zamenjaj tekmovanje</Menu> na vrhu menija in izberite novo kartico.
        </li>
      </UL>
    </>
  );
}

export function Lifecycle() {
  return (
    <>
      <P>
        Vsako tekmovanje gre skozi stanja. Naprej ga premika organizator z gumbi pri tekmovanju v{' '}
        <Menu>Upravljanje tekmovanj</Menu>.
      </P>
      <Table
        head={['Stanje', 'Kaj pomeni', 'Gumb za naprej']}
        rows={[
          ['Osnutek', 'Organizator še pripravlja tekmovanje. Javna stran razpisa še ni vidna.', 'Načrtuj'],
          ['Načrtovano', 'Tekmovanje je objavljeno, a oddaja se še ni začela.', 'Aktiviraj'],
          ['Aktivno', 'Tekmovalci oddajajo prispevke (do roka za oddajo).', 'Začni pregled'],
          [
            'Pregled',
            'Oddaja je zaprta. Organizator vsak prispevek sprejme ali zavrne.',
            'Začni ocenjevanje (možna tudi vrnitev na aktivno)',
          ],
          [
            'Ocenjevanje',
            'Sodniki ocenjujejo sprejete prispevke. Ocenjevanje se začne šele, ko so vsi prispevki pregledani.',
            'Zaključi ocenjevanje (možna vrnitev na pregled ali aktivno)',
          ],
          [
            'Podeljevanje nagrad',
            'Ocene so zaklenjene. Organizator določi, kolikšen delež najboljših gre na razstavo, in podeli nagrade. Tekmovalci in sodniki tega še ne vidijo.',
            'Objavi rezultate (možna vrnitev na ocenjevanje)',
          ],
          [
            'Zaključeno',
            'Rezultati, izbor za razstavo in nagrade so objavljeni.',
            'Arhiviraj (možna vrnitev na podeljevanje nagrad ali aktivno)',
          ],
          ['Arhivirano', 'Končno stanje. Tekmovanja ni več mogoče spreminjati.', '—'],
        ]}
      />
      <Note>
        Ob prehodu iz pregleda v ocenjevanje vsak tekmovalec z odločenimi prispevki prejme e-pošto s seznamom sprejetih
        in zavrnjenih prispevkov (z razlogi zavrnitve).
      </Note>
    </>
  );
}

export function Visitor() {
  return (
    <>
      <H3>Javna stran razpisa</H3>
      <P>
        Vsako objavljeno tekmovanje ima javno stran na naslovu <Menu>/razpis/…</Menu>, ki jo lahko prebere vsak, tudi
        brez računa. Na njej so: opis tekmovanja, datumi (sprejem del, ocenjevanje), razpis kot dokument PDF (pravila,
        nagrade, žirija in kontakt so v njem), tehnične zahteve za fotografije in kategorije. Razpis odprete ali
        prenesete s klikom nanj. Povezavo organizator deli, na primer na spletni strani društva.
      </P>
      <H3>Prijava na tekmovanje</H3>
      <OL>
        <li>
          Odprite povezavo na razpis, ki jo dobite od organizatorja. Če računa še nimate, pritisnite{' '}
          <Menu>Ustvari račun in se prijavi</Menu>, sicer se prijavite.
        </li>
        <li>
          Če so prijave odprte, vas račun takoj prijavi na tekmovanje, kdor ima račun že, pritisne{' '}
          <Menu>Prijavi se na tekmovanje</Menu>. Organizator prejme obvestilo.
        </li>
        <li>Odpre se stran tekmovanja z obrazcem za oddajo, tako da lahko takoj naložite fotografije.</li>
      </OL>
      <Note>
        Prispevkov, ocen in nagrad drugih ne vidite. To velja tudi za rezultate: vidite jih šele po zaključku tekmovanja,
        in samo svoje. Če vas organizator odstrani s tekmovanja, tekmovanje izgine z vaše izbire.
      </Note>
    </>
  );
}

export function Competitor() {
  return (
    <>
      <H3>Oddaja prispevka</H3>
      <P>
        Odprite tekmovanje, izberite kategorijo in slike povlecite na stran ali jih izberite v razdelku za oddajo. Za vsako sliko nastane en
        prispevek, ki je oddan takoj. Naslov prispevka je privzeto ime datoteke, preimenujete ga lahko pri prispevku, dokler
        ga organizator ni sprejel ali zavrnil.
      </P>
      <UL>
        <li>
          Slike lahko tudi povlečete z miško kamor koli na stran tekmovanja: ko jih držite nad stranjo, se prikaže obvestilo
          »Spustite slike za oddajo«. Ko jih spustite, se takoj naložijo in oddajo v izbrano kategorijo (brez dodatnega
          klika). Zahteve za slike veljajo enako kot pri ročni izbiri.
        </li>
        <li>
          V kategorijo lahko oddate največ toliko prispevkov, kolikor določa organizator. Ko je kvota porabljena, se
          kategorija ne ponuja več.
        </li>
        <li>Oddaja je mogoča samo, ko je tekmovanje aktivno in pred rokom za oddajo.</li>
        <li>Oddani prispevki so na strani tekmovanja razvrščeni po kategorijah: nad vsako skupino slik je ime kategorije in število prispevkov.</li>
        <li>
          Napačen prispevek lahko izbrišete (ikona koša nad sliko, izbriše prispevek skupaj s sliko) in naložite pravega, dokler ga ni sprejel ali zavrnil organizator.
        </li>
      </UL>
      <Figure src="/guide/oddaja.png" alt="Obrazec za oddajo prispevka" caption="Obrazec za oddajo: zahteve za sliko so napisane nad izbiro datoteke, pod naslovom je vaš napredek po kategorijah." />
      <H3>Plačilo kotizacije</H3>
      <P>
        Če organizator zahteva kotizacijo, se nad obrazcem za oddajo pokaže kartica <Menu>Kotizacija</Menu> z zneskom.
        Plačate lahko na enega od načinov, ki ga je organizator vklopil. Če kotizacije ni, kartice ne vidite.
      </P>
      <UL>
        <li>
          <Menu>S kartico</Menu>: pritisnite <Menu>Plačaj</Menu>, odprla se bo varna stran Stripe. Podatkov o kartici ne vidimo
          ne mi ne organizator. Po plačilu se vrnete na tekmovanje, oznaka <Menu>Plačano</Menu> pa se prikaže sama.
        </li>
        <li>
          <Menu>Z bančnim nakazilom</Menu>: skenirajte QR kodo v mobilni banki (koda vsebuje znesek, IBAN, sklic in namen) ali
          nakažite ročno z navedenimi podatki. Organizator plačilo označi, ko ga prejme, zato oznaka ni takojšnja.
        </li>
      </UL>
      <Figure src="/guide/tekmovalec-placilo.png" alt="Kartica s kotizacijo" caption="Kotizacija: plačilo s kartico in UPN QR koda za bančno nakazilo." />
      <Note>Oddaja prispevkov ni odvisna od plačila: plačilo organizator le spremlja.</Note>
      <H3>Zahteve za slike</H3>
      <P>
        Organizator lahko določi format (JPG, PNG, WebP), največjo velikost datoteke, velikost daljše stranice v pikslih,
        najmanjšo ločljivost (dpi) in obvezne podatke EXIF. Zahteve so napisane nad obrazcem za oddajo in na javni strani
        razpisa. Brskalnik pred nalaganjem preveri format, velikost in dolžino stranice. Ločljivost in EXIF preveri strežnik takoj
        po nalaganju.
      </P>
      <P>Kaj se zgodi s sliko, ki zahtev ne izpolnjuje, določi organizator pri vsakem tekmovanju:</P>
      <UL>
        <li>
          <Menu>Zavrni takoj</Menu>: slika se ne sprejme in dobite razlog, kaj popraviti (npr. »Daljša stranica slike mora
          imeti natančno 3000 px«).
        </li>
        <li>
          <Menu>Sprejmi in označi</Menu>: slika ostane, prispevek pa dobi rumeno opozorilo, kaj ne ustreza. Priporočamo,
          da sliko zamenjate. Organizator lahko prispevek pozneje zavrne in vam pove razlog.
        </li>
      </UL>
      <Figure src="/guide/opozorilo.png" alt="Opozorilo, da slika ne ustreza zahtevam" caption="Če organizator slike ne zavrne takoj, prispevek dobi opozorilo, kaj ne ustreza zahtevam." />
      <H3>Moji prispevki</H3>
      <P>Seznam vaših prispevkov z majhnimi slikami in stanjem:</P>
      <Table
        head={['Stanje', 'Pomen']}
        rows={[
          ['Osnutek', 'Prispevek je ustvarjen, a še ni oddan.'],
          ['Oddan', 'Čaka na pregled organizatorja.'],
          ['Sprejet', 'Organizator ga je sprejel, sodelovali bo pri ocenjevanju.'],
          ['Zavrnjen', 'Organizator ga je zavrnil. Razlog (če ga je napisal) vidite pri prispevku.'],
        ]}
      />
      <H3>Moji rezultati</H3>
      <P>
        Po zaključku tekmovanja vidite za vsak prispevek povprečno oceno, mesto v kategoriji, mesto na tekmovanju, število
        ocen, oznako »Izbrano za razstavo« (če je bil prispevek med najboljšimi) in prejete nagrade. Dokler tekmovanje ni zaključeno, se prikaže obvestilo, da rezultati še niso objavljeni.
        Pri zavrnjenem prispevku vidite razlog zavrnitve. Enaka povprečna ocena pomeni skupno mesto (npr. dve prvi mesti,
        potem tretje).
      </P>
      <Figure src="/guide/rezultati.png" alt="Stran Moji rezultati" caption="Moji rezultati: ocena, mesto v kategoriji, mesto na tekmovanju in nagrade." />
    </>
  );
}

export function Organizer() {
  return (
    <>
      <P>
        Organizator vodi tekmovanja svoje organizacije. Njegov del menija je <Menu>Organizator</Menu>: Pregled, Upravljanje
        tekmovanj in Poročila. Strani posameznega tekmovanja se odprejo z gumbi v vrstici tekmovanja.
      </P>
      <H3>Pregled</H3>
      <P>
        Povzetek vseh vaših tekmovanj: koliko je aktivnih, koliko prispevkov je oddanih, kako daleč je ocenjevanje in kaj
        potrebuje pozornost (npr. prispevki, ki čakajo na pregled, ali bližajoči se roki).
      </P>
      <H3>Upravljanje tekmovanj</H3>
      <UL>
        <li>
          <Menu>Novo tekmovanje</Menu>: izberite organizacijo, naziv in kratek opis. Novo tekmovanje je vedno osnutek.
        </li>
        <li>
          <Menu>Uredi</Menu>: naziv, opis, odprtje za oddajo, rok za oddajo in rok za ocenjevanje (datum in ura), datum začetka in
          konca ter logotip dogodka (nadomesti logotip organizacije). Zaključenega ali arhiviranega tekmovanja ni mogoče
          urejati.
        </li>
        <li>
          Gumbi za stanje (Načrtuj, Aktiviraj, Začni pregled, …) premikajo tekmovanje po življenjskem krogu, opisanem
          zgoraj.
        </li>
        <li>
          <Menu>Označi kot FZS</Menu>: tekmovanje je pod pokroviteljstvom Fotografske zveze Slovenije, ob nazivu se prikaže
          oznaka.
        </li>
        <li>
          <Menu>Izbriši</Menu>: če ima tekmovanje oddane prispevke, vas program vpraša še enkrat. Če potrdite, se skupaj s tekmovanjem trajno izbrišejo tudi vsi prispevki, ocene in nagrade, tega ni mogoče razveljaviti.
        </li>
      </UL>
      <Figure src="/guide/organizer-tekmovanja.png" alt="Upravljanje tekmovanj" caption="Upravljanje tekmovanj: gumbi za stanje tekmovanja in za posamezne strani (Razpis, Kategorije, Nagrade, Sodniki, Tekmovalci)." />
      <H3>Razpis (javna stran) in zahteve za slike</H3>
      <P>
        Gumb <Menu>Razpis</Menu> odpre stran, s katero sestavite javno stran tekmovanja. Opis tekmovanja in datume
        urejate pri <Menu>Uredi</Menu> na seznamu tekmovanj, na tej strani pa naložite razpis in določite zahteve za slike:
      </P>
      <UL>
        <li>
          <Menu>Razpis (PDF)</Menu>: naložite razpis kot dokument PDF (do 20 MB). Pravila sodelovanja, nagrade, žirijo
          in kontakt napišite v razpis. Z <Menu>Zamenjaj PDF</Menu> ga zamenjate, z <Menu>Odstrani</Menu> pa odstranite.
        </li>
        <li>
          <Menu>Zahteve za fotografije</Menu>: dovoljeni formati, največja velikost datoteke (MB), najmanjša ločljivost (dpi),
          najmanjša in največja dolžina daljše stranice (px; če mora biti natančna, vpišite isto število v obe polji) in ali so
          podatki EXIF obvezni. Prazno polje pomeni brez omejitve.
        </li>
        <li>
          <Menu>Slika, ki ne ustreza zahtevam</Menu>: <Menu>Zavrni takoj</Menu> (tekmovalec slike ne more oddati) ali{' '}
          <Menu>Sprejmi in označi</Menu> (slika ostane z opozorilom, vi jo lahko pozneje zavrnete).
        </li>
        <li>
          <Menu>Ogled javne strani</Menu> odpre stran, kot jo vidijo obiskovalci. Draft vidite samo vi.
        </li>
      </UL>
      <Note>
        Primer: razpis ENA/a 2026 zahteva samo JPG, 3000 px na daljši stranici, 300 dpi, največ 3 MB in podatke EXIF. V
        obrazcu vnesete: format JPG, velikost 3 MB, ločljivost 300, daljša stranica najmanj 3000 in največ 3000, EXIF
        obvezen.
      </Note>
      <H3>Kategorije</H3>
      <P>
        Vsako tekmovanje ima eno ali več kategorij (naziv, neobvezen opis in največ prispevkov na tekmovalca). Kategorije
        se prikažejo tekmovalcem in na javni strani razpisa.
      </P>
      <H3>Tekmovalci</H3>
      <UL>
        <li>
          Seznam prijavljenih z e-pošto in datumom. Tekmovalci se prijavijo sami prek povezave na razpis (gumb{' '}
          <Menu>Kopiraj povezavo</Menu>) in lahko takoj oddajajo. V stolpcu <Menu>Plačilo</Menu> označite, kdo je že plačal in kako
          (bančno nakazilo ali kartica; oznako lahko kadar koli odstranite).
        </li>
        <li>
          <Menu>Dodaj tekmovalca</Menu>: izberite obstoječega uporabnika ali vnesite e-pošto, ime in priimek. Novi uporabnik dobi
          povabilo s povezavo za izbiro gesla. Gesla ne nastavljate vi.
        </li>
        <li>
          Prijave lahko odprete ali zaprete (samostojne prijave tekmovalcev) in tekmovalca odstranite.
        </li>
      </UL>
      <H3>Plačila: kotizacija, QR koda in Stripe</H3>
      <P>
        Plačila so neobvezna in so izklopljena, dokler ne vpišete kotizacije. Nastavite jih pri tekmovanju na strani{' '}
        <Menu>Plačila</Menu>. Kotizacija velja za tekmovanje, podatki o klubu (prejemnik, IBAN, Stripe) pa za vse tekmovanja
        vašega kluba, zato jih vnesete samo enkrat.
      </P>
      <Figure src="/guide/organizer-placila.png" alt="Stran Plačila" caption="Plačila: kotizacija, podatki za QR kodo in ključa za Stripe. Shranjenih ključev stran nikoli ne pokaže, vidite le zadnje znake." />
      <H3>Bančno nakazilo z UPN QR kodo</H3>
      <OL>
        <li>Pri <Menu>Plačila</Menu> vpišite znesek kotizacije.</li>
        <li>
          Pod <Menu>Bančno nakazilo</Menu> vpišite prejemnika, naslov in IBAN kluba ter vklopite <Menu>Pokaži QR kodo</Menu>.
          IBAN se preveri (kontrolna števka).
        </li>
        <li>
          Tekmovalec dobi kodo, ki jo prebere mobilna banka. Sklic je za vsakega tekmovalca drugačen, da plačilo prepoznate.
        </li>
        <li>
          Ko nakazilo prispe, pri tekmovalcu izberite <Menu>Plačano: bančno nakazilo</Menu>.
        </li>
      </OL>
      <H3>Plačilo s kartico: nastavitev Stripe</H3>
      <P>
        Kartična plačila opravi Stripe, ki denar nakaže neposredno na račun vašega kluba. Podatkov o kartici platforma ne vidi.
        Nastavitev traja približno deset minut in jo naredite enkrat. Zaslonka ne prikazuje zaslonskih slik Stripe, ker se njihov
        vmesnik spreminja. Imena menijev spodaj so zato napisana tako, kot jih najdete v Stripe.
      </P>
      <OL>
        <li>
          Na <Menu>stripe.com</Menu> ustvarite račun za klub in dokončajte aktivacijo (podatki o društvu, bančni račun za izplačila).
          Stripe zaračuna provizijo za vsako plačilo, cenik je na njihovi strani.
        </li>
        <li>
          Najprej preizkusite v testnem načinu: v Stripe preklopite na <Menu>testni način</Menu> (sandbox). Tam ustvarjeni ključi
          se začnejo z <Menu>rk_test_</Menu>, pravi z <Menu>rk_live_</Menu>.
        </li>
        <li>
          V Stripe odprite <Menu>Developers → API keys</Menu> in pritisnite <Menu>Create restricted key</Menu>. Ključ omejite:
          pri <Menu>Checkout Sessions</Menu> izberite <Menu>Write</Menu>, vse ostalo pustite na <Menu>None</Menu>. Tako ključ lahko
          samo ustvari plačilno stran in ničesar drugega. Kopirajte ga (Stripe ga pokaže samo enkrat).
        </li>
        <li>
          V Zaslonki pri <Menu>Plačila</Menu> prilepite ključ v polje <Menu>Stripe skrivni ali omejeni ključ</Menu>. Na isti strani
          je <Menu>Naslov webhooka</Menu>: kopirajte ga.
        </li>
        <li>
          V Stripe odprite <Menu>Developers → Webhooks → Add endpoint</Menu>. Prilepite naslov webhooka in izberite dogodka{' '}
          <Menu>checkout.session.completed</Menu> in <Menu>checkout.session.async_payment_succeeded</Menu>. Po shranjevanju
          odprite webhook in kopirajte <Menu>Signing secret</Menu> (začne se z <Menu>whsec_</Menu>).
        </li>
        <li>
          V Zaslonki ga prilepite v polje <Menu>Podpisna skrivnost webhooka</Menu>, vklopite{' '}
          <Menu>Omogoči plačilo s kartico</Menu> in pritisnite <Menu>Shrani</Menu>.
        </li>
        <li>
          Preizkus: kot tekmovalec pritisnite <Menu>Plačaj</Menu> in vpišite testno kartico 4242 4242 4242 4242 (poljuben
          prihodnji datum in CVC). Oznaka <Menu>Plačano (kartica)</Menu> se mora pojaviti sama.
        </li>
        <li>
          Ko deluje, ponovite korake 3 do 6 v živem načinu (ključ <Menu>rk_live_</Menu>, nov webhook in nova podpisna
          skrivnost) in shranite. Webhook deluje samo na javno dostopni strani, ne na računalniku doma.
        </li>
      </OL>
      <Note>
        Varnost: ključa sta shranjena šifrirano (AES-256), ju stran nikoli ne pokaže nazaj in ju ne vidi nihče, niti
        administratorji platforme. Vsak prejeti dogodek preveri podpis Stripe, zato ponarejenega plačila ni mogoče sprožiti.
        Ključev nikoli ne pošiljajte po e-pošti. Če sumite, da je ključ uhajal, ga v Stripe zamenjajte (<Menu>Roll key</Menu>) in
        v Zaslonki vpišite novega ali pritisnite <Menu>Izbriši shranjena ključa</Menu>.
      </Note>
      <H3>Spremljanje plačil</H3>
      <P>
        Na strani <Menu>Tekmovalci</Menu> je pri vsakem tekmovalcu izbira <Menu>Plačilo</Menu>: <Menu>Ni plačano</Menu>,{' '}
        <Menu>Plačano: bančno nakazilo</Menu> ali <Menu>Plačano: kartica</Menu>. Kartična plačila označi Stripe sam, bančna
        nakazila označite vi. Nad seznamom je število plačnikov.
      </P>
      <H3>Sodniki</H3>
      <P>
        Dodajte sodnike (obstoječega uporabnika ali novega z e-pošto) in spremljajte njihov napredek: koliko prispevkov so
        ocenili, po kategorijah in kdaj so oddali zadnjo oceno. Sodnik dobi e-pošto ob dodelitvi.
      </P>
      <H3>Pregled prispevkov</H3>
      <P>
        Ko je tekmovanje v stanju Pregled, odprite tekmovanje: vidite vse prispevke, filter po kategoriji in
        »čaka na pregled«. Vsak prispevek <Menu>sprejmete</Menu> ali <Menu>zavrnete</Menu>. Pri zavrnitvi lahko napišete razlog
        (do 500 znakov), ki ga avtor vidi. Če ima slika opozorilo o neizpolnjenih zahtevah, je razlog že predlagan. Ocenjevanje
        se lahko začne šele, ko so vsi prispevki odločeni.
      </P>
      <H3>Nagrade</H3>
      <OL>
        <li>
          <Menu>Vrste nagrad</Menu>: določite nagrade (naziv, neobvezen opis, kategorija ali splošna, mesto in število podelitev),
          npr. »Grand Prix«, »Zlata medalja v kategoriji Pokrajina«. Urejate in brišete jih lahko.
        </li>
        <li>
          Ko zaključite ocenjevanje in je tekmovanje v stanju <Menu>Podeljevanje nagrad</Menu>, vnesite pri{' '}
          <Menu>Izbor za razstavo</Menu> delež najboljših prispevkov (običajno 20 do 35 %) in pritisnite{' '}
          <Menu>Izberi najboljše</Menu>. Vsi sprejeti prispevki so že v tekmovanju, na razstavo gredo najboljši po
          povprečni oceni, v vsaki kategoriji posebej. Izbor lahko ponovite z drugim deležem.
        </li>
        <li>
          Stran prikaže razvrstitev po povprečni oceni z oznako »Izbrano« pri izbranih prispevkih. Pri vsakem prispevku
          pritisnite <Menu>Podeli nagrado</Menu> in izberite eno od še prostih nagrad.
        </li>
        <li>Podeljeno nagrado lahko prekličete.</li>
        <li>
          Ko je vse pripravljeno, pritisnite <Menu>Objavi rezultate</Menu> na seznamu tekmovanj. Šele takrat tekmovalci
          vidijo ocene, mesta, izbor za razstavo in nagrade.
        </li>
      </OL>
      <UL>
        <li>Nagrada se podeli samo sprejetemu prispevku tega tekmovanja, v ustrezni kategoriji.</li>
        <li>Izbor za razstavo in nagrade so skriti pred tekmovalci in sodniki, dokler ne objavite rezultatov.</li>
        <li>Če vrnete tekmovanje na ocenjevanje, se izbor za razstavo izbriše; podeljene nagrade ostanejo.</li>
        <li>Izenačeni prispevki na meji izbora so izbrani skupaj, zato je izbranih lahko malo več, kot pove odstotek.</li>
        <li>Ista nagrada ne more dvakrat na isti prispevek in ne več, kot je določeno število.</li>
        <li>
          <Menu>Izenačeno</Menu>: prispevki z enako povprečno oceno si delijo mesto. O zmagovalcu odloči žirija izven
          aplikacije, organizator nagrado podeli izbranemu prispevku.
        </li>
      </UL>
      <Figure src="/guide/nagrade.png" alt="Stran Nagrade" caption="Nagrade: vrste nagrad, izbor za razstavo in razvrstitev s podelitvijo. Izenačeni prispevki imajo oznako »Izenačeno«." />
      <H3>Poročila</H3>
      <P>
        Ustvarite povzetek tekmovanja, ali rezultate ocenjevanja. Poročila nastajajo v ozadju (PDF), ko so
        pripravljena, jih prenesete. Neuspešno poročilo prikaže razlog.
      </P>
    </>
  );
}

export function Judge() {
  return (
    <>
      <P>
        Sodnik vidi del menija <Menu>Sodnik</Menu>, ko je dodan na tekmovanje.
      </P>
      <H3>Ocenjevanje</H3>
      <UL>
        <li>
          Stran <Menu>Ocenjevanje</Menu> je čakalna vrsta sprejetih prispevkov, razdeljena po kategorijah, z merilnikom napredka.
        </li>
        <li>Slika se odpre v velikem prikazu (celozaslonski prikaz in vrtenje slike sta na voljo).</li>
        <li>
          Oceno od 1 do 10 izberete s klikom ali s tipkami 1 do 9 in 0 (to je 10), komentar je neobvezen. Enter shrani oceno
          in odpre naslednjo sliko, puščici levo in desno premikata med slikami, R zavrti sliko.
        </li>
        <li>
          Ocena je vaša: drugi sodniki je ne vidijo, avtor prispevka tudi ne, dokler tekmovanje ni zaključeno. Dokler ocenjevanje
          traja, jo lahko spremenite z gumbom <Menu>Uredi oceno</Menu>.
        </li>
        <li>Ocenjevati je mogoče samo, ko je tekmovanje v stanju Ocenjevanje.</li>
      </UL>
      <Figure src="/guide/sodnik-vrsta.png" alt="Čakalna vrsta za ocenjevanje" caption="Čakalna vrsta: napredek ocenjevanja in prispevki po kategorijah." />
      <Figure src="/guide/sodnik-ocenjevanje.png" alt="Ocenjevanje prispevka" caption="Ocenjevanje: velika slika, ocena od 1 do 10, komentar in bližnjice na tipkovnici." />
      <H3>Razvrstitev</H3>
      <P>
        Po zaključku tekmovanja <Menu>Razvrstitev</Menu> pokaže prispevke po povprečni oceni, razvrščene po kategorijah. Enaka
        povprečna ocena pomeni skupno mesto in oznako »Izenačeno«, kar je znak, da mora žirija odločiti, kdo prejme nagrado.
      </P>
      <Figure src="/guide/sodnik-razvrstitev.png" alt="Razvrstitev" caption="Razvrstitev po zaključku tekmovanja." />
    </>
  );
}


export function Rules() {
  return (
    <>
      <H3>Kdo kaj vidi</H3>
      <UL>
        <li>Javni razpis: vsakdo, ko tekmovanje ni več osnutek.</li>
        <li>Vsebino tekmovanja (kategorije, prispevke): organizatorji, sodniki in sprejeti tekmovalci.</li>
        <li>Rezultate in nagrade tekmovalcev: šele po zaključku tekmovanja, vsak samo svoje.</li>
        <li>Sodniki ne vidijo ocen drugih sodnikov in razvrstitve, dokler ocenjevanje ni zaključeno.</li>
      </UL>
      <H3>Obvestila po e-pošti</H3>
      <P>
        Platforma pošilja e-pošto v slovenščini: dobrodošlica, ponastavitev in sprememba gesla, povabilo, dodelitev sodniku ali
        tekmovanju, odločitev o prijavi, nova prijava (organizatorjem) in izid pregleda prispevkov.
      </P>
      <H3>Če nekaj ne deluje</H3>
      <UL>
        <li>Meni ne pokaže strani: tisti del vam ni dodeljen. Organizator vas lahko doda na tekmovanje.</li>
        <li>Slika ostane dolgo v obdelavi: osvežite stran čez trenutek, obdelava poteka v ozadju.</li>
        <li>Slika je bila zavrnjena: preberite razlog in naložite popravljeno sliko.</li>
        <li>Povezava za geslo ne deluje: potekla je ali je bila že uporabljena, zahtevajte novo.</li>
      </UL>
    </>
  );
}

